import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { ROOT, LOGIN } from '../constants/routes';

interface Props extends RouteProps {
  isLoggedIn: boolean;
}

export const Private = function Private({
  isLoggedIn,
  children,
  ...rest
}: Props): JSX.Element {
  return isLoggedIn ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Route {...rest}>{children}</Route>
  ) : (
    <Redirect to={{ pathname: LOGIN.to }} />
  );
};

export const Public = function Public({
  isLoggedIn,
  children,
  ...rest
}: Props): JSX.Element {
  return isLoggedIn ? (
    <Redirect to={{ pathname: ROOT.to }} />
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Route {...rest}>{children}</Route>
  );
};
